export abstract class TabsStrategyService {
  abstract makeTabs();

  getTabProps( params: Record<string, string>): Record<string, string> {
      return {};
  }
}
